import { render, staticRenderFns } from "./ChatMessageWelcome.vue?vue&type=template&id=3b749a66&"
import script from "./ChatMessageWelcome.vue?vue&type=script&lang=js&"
export * from "./ChatMessageWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatIconBubble: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatIconBubble.vue').default})
